import React from 'react'
import './advantages.css'

function Advantages({language}) {
    return (
        <section className='advantages_section'>
            <div className='advantages_content'>
                <div className='list'>
                    <div className='list_item'>
                        <p style={{fontSize: '1.2rem', textAlign: 'center', color: '#fca311'}}>{language === 'deutsch' ? 'ZERTIFIKATE' : 'CERTIFICATES'}</p>
                        <p style={{textAlign: 'center'}}>{language === 'deutsch' ? 'Das Zertifikat stellen wir noch am selben Tag des Kursabschlusses aus!' : 'We issue the certificate on the same day as the course completion!'}</p>
                    </div>
                    <div className='list_item'>
                        <p style={{fontSize: '1.2rem', textAlign: 'center', color: '#fca311'}}>{language === 'deutsch' ? 'GESCHULTES PERSONAL' : 'TRAINED STAFF'}</p>
                        <p style={{textAlign: 'center'}}>{language === 'deutsch' ? 'Unsere Dozenten sprechen über 5 Sprachen, darunter Polnisch, Deutsch, Englisch, Rumänisch und Kroatisch.' : 'Our lecturers speak over 5 languages, including Polish, German, English, Romanian and Croatian.'}</p>
                    </div>
                    <div className='list_item'>
                        <p style={{fontSize: '1.2rem', textAlign: 'center', color: '#fca311'}}>{language === 'deutsch' ? 'GÜLTIGKEITSDAUER' : 'PERIOD OF VALIDITY'}</p>
                        <p style={{textAlign: 'center'}}>{language === 'deutsch' ? 'Das Abschlussdokument ist lebenslang gültig.' : 'The course completion document is valid for life.'}</p>
                    </div>
                    <div className='list_item'>
                        <p style={{fontSize: '1.2rem', textAlign: 'center', color: '#fca311'}}>{language === 'deutsch' ? 'ZUSÄTZLICHE STUNDEN' : 'ADDITIONAL HOURS'}</p>
                        <p style={{textAlign: 'center'}}>{language === 'deutsch' ? 'Bei uns sind zusätzliche Praxisstunden kostenlos!' : 'With us, additional practical hours are free of charge!'}</p>
                    </div>
                    <div className='list_item'>
                        <p style={{fontSize: '1.2rem', textAlign: 'center', color: '#fca311'}}>{language === 'deutsch' ? 'KEINE VERSTECKTEN KOSTEN' : 'NO HIDDEN COSTS'}</p>
                        <p style={{textAlign: 'center'}}>{language === 'deutsch' ? 'Wir berechnen keine Vorauszahlungen oder versteckte Zahlungen!' : 'We do not charge advance payments or any hidden payments!'}</p>
                    </div>
                </div>
                <div className='title_section'>
                    <div className='fixed_text'>
                        <p style={{fontSize: '2rem'}}>{language === 'deutsch' ? 'Vorteile' : 'Advantages'}</p>
                        <p>{language === 'deutsch' ? 'Sie haben die Möglichkeit, von den besten Trainern zu lernen und mühelos Ihr Zertifikat zu erhalten.' : 'You get to learn from the best trainers and get your certificate with ease.'}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Advantages